import type { CatalogTree } from '../types';

// The strings of merchant screens §3.1; the API error texts come from the shared catalog through ApiError.message.
export const auth = {
  fields: {
    email: 'E-posta',
    password: 'Şifre',
    passwordRepeat: 'Şifre (tekrar)',
    passwordHint: 'En az 10 karakter.',
    passwordMismatch: 'Şifreler aynı değil.',
  },
  login: {
    title: 'Giriş yap',
    submit: 'Giriş yap',
    forgot: 'Şifremi unuttum',
    signup: 'Hesap oluştur',
    code: 'Doğrulama kodu',
    verify: 'Doğrula',
    useRecoveryCode: 'Kurtarma kodu kullan',
    recoveryCode: 'Kurtarma kodu',
    attemptsLeft: 'Kalan deneme: {n}',
    enrolment: {
      qrLabel: 'Doğrulama uygulaması için QR kodu',
      secret: 'Gizli anahtar',
      hint: 'Google Authenticator veya benzeri bir doğrulama uygulamasıyla QR kodu tarayın ya da gizli anahtarı girin.',
      note: 'Kodu doğrulayınca iki adımlı doğrulama etkinleşir.',
    },
    recoveryCodes: {
      title: 'Kurtarma kodları',
      description: 'Bu kodlar yalnızca bir kez gösterilir.',
      saved: 'Kodları kaydettim',
      continue: 'Devam et',
    },
  },
  signup: {
    title: 'Hesap oluştur',
    businessName: 'İşletme adı',
    taxId: 'Vergi numarası',
    taxIdInvalid: 'Vergi numarası 10 veya 11 haneli olmalı.',
    contactName: 'Yetkili adı',
    phone: 'Cep telefonu',
    terms:
      'ESNAF AI kullanım şartlarını, gizlilik politikasını ve mesafeli satış sözleşmesini okudum ve kabul ediyorum',
    termsRequired: 'Devam etmek için kullanım şartlarını kabul edin.',
    submit: 'Hesap oluştur',
    haveAccount: 'Zaten hesabınız var mı?',
    loginLink: 'Giriş yapın',
    sent: 'E-postanıza bir doğrulama bağlantısı gönderdik. Bağlantı 24 saat geçerlidir.',
    login: 'Giriş yap',
  },
  invitation: {
    title: 'Davete katıl',
    invited: '{inviter} sizi {business} ekibine davet etti.',
    role: 'Rolünüz: {role}',
    name: 'Adınız',
    submit: 'Katıl',
    expired: 'Davet bağlantısının süresi dolmuş. İşletme sahibinden yeni bir davet isteyin.',
  },
  verifyEmail: {
    title: 'E-posta doğrulama',
    verifying: 'Doğrulanıyor…',
    verified: 'E-posta adresiniz doğrulandı.',
    continue: 'Devam et',
    expired: 'Bağlantının süresi dolmuş.',
    notVerified: 'E-posta adresiniz henüz doğrulanmadı.',
    resend: 'Doğrulama e-postasını yeniden gönder',
    login: 'Giriş yap',
  },
  passwordReset: {
    title: 'Şifremi unuttum',
    send: 'Bağlantı gönder',
    requested: 'E-posta adresiniz kayıtlıysa bir bağlantı gönderdik.',
    newPassword: 'Yeni şifre',
    newPasswordRepeat: 'Yeni şifre (tekrar)',
    save: 'Şifreyi kaydet',
    saved: 'Şifreniz kaydedildi.',
    login: 'Giriş yap',
    expired: 'Bağlantının süresi dolmuş. Yeni bir bağlantı isteyin.',
    requestAgain: 'Yeni bağlantı iste',
  },
} as const satisfies CatalogTree;
